app.service('toCartView', function (pageConfig, front, log, cookie, accessoryCrossselling, goBack) {
	var config;

	function init() {
		config = pageConfig.getData('precart');
		if (typeof config.cartStepOrderInfo !== 'undefined') {
			log.event(
				prepareCartStepLogEventData(config.cartStepOrderInfo)
			);
		}
		accessoryCrossselling.init();
		$('#to-cart .js-back-to-offer').on('click', function () {
			goBack.go();
		});
	}

	function prepareCartStepLogEventData(cartStepOrderInfo) {
		var cartStepLogEventData = {
			id:'cart_step',
		}
		// f04 : numer zamówienia
		// cartStepLogEventData.f04 = ''; //nie wysyłamy na tym kroku

		// f05 : wartość koszyka
		cartStepLogEventData.f05 = cartStepOrderInfo.paymentTotal;

		// f06 : typ płatności
		// cartStepLogEventData.f06 = ''; //nie wysyłamy na tym kroku
		// cartStepLogEventData.f06 = ''; //nie wysyłamy na tym kroku

		// f07 : typ dostawy
		// cartStepLogEventData.f07 = ''; //nie wysyłamy na tym kroku

		// f08 : czy jest kod rabatowy
		// cartStepLogEventData.f08 = ''; //nie wysyłamy na tym kroku

		// f09 : ''
		// cartStepLogEventData.f09 = ''; //puste

		// f10 : ''
		// cartStepLogEventData.f10 = ''; //puste

		// f11 : numer koszyka
		var cookieCart = front.euro ? 'euroCart' : 'oleoleCart';
		cartStepLogEventData.f11 = cookie.get(cookieCart);

		// f12 : Plu produktów w koszyku, po średniku
		cartStepLogEventData.f12 = cartStepOrderInfo.productsCodes;

		// f13 : krok koszyka
		cartStepLogEventData.f13 = 'K0';

		// f14 : czy zalogowany
		cartStepLogEventData.f14 = cartStepOrderInfo.frontUserId;

		// f15 : ''
		// cartStepLogEventData.f15 = ''; //nie wysyłamy na tym kroku

		// f16 : ścieżka ratalna
		cartStepLogEventData.f16 = cartStepOrderInfo.isInstalmentPayment == 'true' ? 'INSTALLMENT' : 'CASH';

		// f17 : wybrany temin dostawy
		// cartStepLogEventData.f17 = ''; //nie wysyłamy na tym kroku

		// f18 : wybrana godzina dostawy
		// cartStepLogEventData.f18 = ''; //nie wysyłamy na tym kroku

		// f19 : czy na firmę
		// cartStepLogEventData.f19 = ''; //nie wysyłamy na tym kroku

		// f20 : Czy wyświetliło się łączenie koszyka?
		// cartStepLogEventData.f20 = ''; //nie wysyłamy na tym kroku

		return cartStepLogEventData;
	}

	return {
		init: init
	};
});
